import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

export async function getUserPermissions(userId, token) {
  const res = await axios.get(`${API}/salons/me/users/${userId}/permissions`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getMyPermissions(token) {
  const res = await axios.get(`${API}/salons/me/users/permissions/me`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateUserPermissions(userId, overrides, token) {
  const res = await axios.patch(
    `${API}/salons/me/users/${userId}/permissions`,
    { overrides },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function resetUserPermissions(userId, token) {
  const res = await axios.post(
    `${API}/salons/me/users/${userId}/permissions/reset`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getPermissionMatrix(token) {
  const res = await axios.get(`${API}/salons/me/users/permission-matrix`, {
    headers: authHeaders(token),
  });
  return res.data;
}
